export default "__VITE_ASSET__b332cf06__"